import React from "react";
import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import TherapistSelector from "@main/therapists/components/TherapistSelector";
import { Gear, Pencil, Plus, Trash, XCircle } from "@phosphor-icons/react";
import { t } from "i18next";

const config = {
  modelName: "schedule",
  modelPluralName: "schedules",
  endpoint: "schedules",
  disabledInEdition: false,
  indexQueryParams: {
    relations: ["therapist", "customer_treatment"],
  },
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: "generate-sessions",
        label: "generate-sessions",
        icon: <Gear size={20} />,
        allowed: true,
        show: (element: any) => {
          return !element.processed;
        },
        action: (element: any) => {
          console.log("generate-sessions", element);
        },
      },
      {
        name: "cancel-schedule",
        label: "cancel-schedule",
        icon: <XCircle size={20} />,
        allowed: true,
        show: (element: any) => {
          // Solo mostrar la acción si el horario NO está cancelado
          return !element.cancelled;
        },
        action: (element: any) => {
          console.log("cancel-schedule", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        // Agregar clase para horarios cancelados
        if (element.cancelled) {
          return "table-secondary text-muted";
        }
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "therapist",
        label: "therapist",
        key: "therapist.name",
        type: "string",
        show: true,
        allowOrder: true,
      },
      {
        name: "start_date",
        label: "start_date",
        key: "start_date",
        type: "date",
        show: true,
        allowOrder: true,
      },
      {
        name: "end_date",
        label: "end_date",
        key: "end_date",
        type: "date",
        show: true,
        allowOrder: true,
      },
      {
        name: "start_hour",
        label: "start_hour",
        key: "start_hour",
        type: "string",
        show: true,
      },
      {
        name: "cancelled",
        label: "cancelled",
        key: "cancelled",
        type: "boolean",
        show: true,
        true_icon: (
          <span className="badge bg-danger">
            {t("schedule_status_cancelled")}
          </span>
        ),
        show_false: false,
      },
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: { type: "string" },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false,
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {
      therapist_id: {
        type: "number",
        title: t("therapist"),
      },
      start_date: {
        type: "string",
        title: t("start_date"),
        format: "date",
      },
      end_date: {
        type: "string",
        title: t("end_date"),
        format: "date",
      },
      start_hour: {
        type: "string",
        title: t("start_hour"),
        format: "time",
      },
      // booleans para días de la semana
      monday: { type: "boolean", title: t("monday") },
      tuesday: { type: "boolean", title: t("tuesday") },
      wednesday: { type: "boolean", title: t("wednesday") },
      thursday: { type: "boolean", title: t("thursday") },
      friday: { type: "boolean", title: t("friday") },
      saturday: { type: "boolean", title: t("saturday") },
      sunday: { type: "boolean", title: t("sunday") },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    monday: { "ui:widget": BeelditSwitchInput },
    tuesday: { "ui:widget": BeelditSwitchInput },
    wednesday: { "ui:widget": BeelditSwitchInput },
    thursday: { "ui:widget": BeelditSwitchInput },
    friday: { "ui:widget": BeelditSwitchInput },
    saturday: { "ui:widget": BeelditSwitchInput },
    sunday: { "ui:widget": BeelditSwitchInput },
    therapist_id: {
      "ui:widget": TherapistSelector,
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            { name: "therapist_id", cols: "col-12" },
            // { name: "customer_treatment_id", cols: "col-6" },
            { name: "start_date", cols: "col-6" },
            { name: "end_date", cols: "col-6" },
            { name: "start_hour", cols: "col-6" },
            { name: "monday", cols: "col-3" },
            { name: "tuesday", cols: "col-3" },
            { name: "wednesday", cols: "col-3" },
            { name: "thursday", cols: "col-3" },
            { name: "friday", cols: "col-3" },
            { name: "saturday", cols: "col-3" },
            { name: "sunday", cols: "col-3" },
          ],
        ],
      },
    ],
  },
};

export default config;
